<template>
    <div class="popup" @click.self="footerClick">
        <div>
            <p class="title">{{header}}</p>
            <slot></slot>
            <p class="footer" @click.stop="footerClick">{{footer}}</p>            
        </div>
    </div>
</template>

<script>
    export default {
        name: "popup",
        props:{
            header: String,
            footer: String
        },
        created: function () {

        },
        methods: {
            footerClick(){
                console.log('emit')
                this.$emit('footerClick')
            }
        },
    }
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5.8rem;
    background-color: #ffffff;
    border-radius: 0.3rem;
    >.title {
        text-align: center;
        font-family: PingFangSC-Semibold;
        line-height: .40rem;
      font-size: .40rem;
      color: #424243;
        margin-top: .51rem;
    }
    .footer {
        width: 100%;
        height: 1.01rem;
        line-height: 1.01rem;
        text-align: center;
        background-color: #85cdfb;
        border-radius: 0px 0px .30rem .30rem;
        font-family: PingFangSC-Semibold;
      font-size: .32rem;
      color: #ffffff;
    }
  }
}
</style>